import { AlertCircle, CheckCircle2, Info, TriangleAlert } from 'lucide-react';

type Tone = 'error' | 'success' | 'info' | 'warning';

const icons = {
  error: AlertCircle,
  success: CheckCircle2,
  info: Info,
  warning: TriangleAlert,
};

/** A dismissible status message. */
export function Alert({
  tone,
  children,
  onDismiss,
}: {
  tone: Tone;
  children: React.ReactNode;
  onDismiss?: () => void;
}) {
  const Icon = icons[tone];
  return (
    <div className={`alert alert-${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <Icon size={17} />
      <div>{children}</div>
      {onDismiss && (
        <button type="button" className="alert-dismiss" onClick={onDismiss} aria-label="Dismiss">
          ×
        </button>
      )}
    </div>
  );
}

/** Placeholder shown when a panel has nothing to display yet. */
export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}

export function Spinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="spinner" role="status">
      <span className="spinner-ring" />
      <span>{label}</span>
    </div>
  );
}
